import { Toasts } from '../../../Components/Toasts/Toasts';
import { apiClient } from '../../../utilities/apiClient';

// Step 1 of admin login: request a magic-link/OTP email. The legacy
// `signInWithEmailAndPassword` flow is gone — admin auth is passwordless,
// same as the marketplace.
export const requestAdminLogin = ({ email }) =>
  apiClient
    .post('/auth/email/request', { email })
    .then(() => {
      Toasts.info('Check your email for the sign-in code.');
      return true;
    })
    .catch((e) => {
      Toasts.error(e?.response?.data?.message || e?.message || 'request failed');
      return false;
    });

// Step 2: verify the 6-digit code. On success the user row is fetched and
// we confirm `isAdmin` — non-admins get logged out and see an error.
export const verifyAdminLogin = ({ email, code }) =>
  apiClient
    .post('/auth/email/verify', { email, code })
    .then((res) => {
      const user = res.data?.user;
      if (!user) {
        Toasts.error('Unexpected response from server');
        return null;
      }
      if (!user.isAdmin) {
        // Mark the just-verified non-admin user out and surface the error.
        apiClient.post('/auth/logout').catch(() => null);
        Toasts.error('Only admins are allowed to use this portal.');
        return null;
      }
      window.localStorage.setItem('user', JSON.stringify(user));
      window.location.reload();
      return user;
    })
    .catch((e) => {
      Toasts.error(e?.response?.data?.message || e?.message || 'invalid code');
      return null;
    });

// Back-compat — older code might import `loginUser`. Maps to the new request
// step; the verify step is wired separately in the UI.
export const loginUser = ({ email }) => requestAdminLogin({ email });
